import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as exportData from "./exportData";
import * as requestExportBiRun from "./requestExportBiRun";
import * as retrieveExportBiRun from "./retrieveExportBiRun";

const initialState: State = {
  exportData: exportData.initialState,
  requestExportBiRun: requestExportBiRun.initialState,
  retrieveExportBiRun: retrieveExportBiRun.initialState,
};

const reduceState = combineStateReducer(initialState, {
  exportData: exportData.reduceState,
  requestExportBiRun: requestExportBiRun.reduceState,
  retrieveExportBiRun: retrieveExportBiRun.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...exportData.createSelector(() => getState().exportData),
    ...requestExportBiRun.createSelector(() => getState().requestExportBiRun),
    ...retrieveExportBiRun.createSelector(() => getState().retrieveExportBiRun),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
